// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__HGDAi","received-icon":"styles_received-icon__-OIGf","share-icon":"styles_share-icon__fJEeP","readonly-icon":"styles_readonly-icon__njG8t"};